import useUserApi from "src/lib/filmwebid/useUserApi";
import { useEffect, useState, useCallback } from "react";

export default function useReviewLike(reviewId: number, edi: string | null | undefined = null, streamingId: number | null | undefined = null, isLiked: boolean | undefined = false)
	: [doLike: (userId: string) => void, isLiking: boolean, isLiked: boolean] {
	const updater = useUserApi();
	const [isLiking, setIsLiking] = useState(false);
	const [payload, setPayload] = useState<IPayload | null>(null);
	const [_isLiked, setIsLiked] = useState(isLiked);

	useEffect(() => {
		if (payload !== null) {
			const _action = async () => {
				if (payload.shouldLike) {
					await updater("/api/Like/LikeReview", { method: "POST", allowAnon: false, body: { reviewId: payload.reviewId, EDI: payload.edi, streamingId: payload.streamingId, listId: payload.listId, userId: payload.userId, source: window?.location?.hostname } })
					setIsLiked(true);
				} else {
					await updater("/api/Like/DeleteReviewLike", { method: "DELETE", allowAnon: false, params: { reviewId: payload.reviewId, EDI: payload.edi, streamingId: payload.streamingId, listId: payload.listId, userId: payload.userId } })
					setIsLiked(false);
				}
				setIsLiking(false);
			};
			setIsLiking(true);
			_action();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [payload]);


	const doLike = useCallback((userId: string) => {
		setPayload({ reviewId, edi, streamingId, userId, shouldLike: !_isLiked });
	}, [reviewId, edi, streamingId, _isLiked]);

	return [doLike, isLiking, _isLiked]
}

interface IPayload {
	reviewId: number;
	shouldLike: boolean;
	edi: string | undefined | null;
	streamingId: number | undefined | null;
	userId: string;
	listId?: number | null;
}